import React from "react";
// import InfiniteCarousel from "react-leaf-carousel";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useTranslation } from "react-i18next";
import "../translations/i18n";
import { AnimatedOnScroll } from "react-animated-css-onscroll";

import { StaticImage } from "gatsby-plugin-image";

function Partners({ language }) {
  const { t } = useTranslation();

  const settings = {
    dots: false,
    infinite: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    speed: 4000,
    autoplaySpeed: 4000,
    cssEase: "linear",
    pauseOnHover: false,
    arrows: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <div id="partners" className={`${language == "ar" ? "arPartners" : "not"}`}>
      <AnimatedOnScroll animationIn="fadeInUp" animationInDelay="500">
        <div className="aboutRightTitle">
          <StaticImage width={20} src="../images/Arrow.svg" alt="arrow" />
          <h1 className="title">{t("clientsSectionTitle")}</h1>
        </div>{" "}
      </AnimatedOnScroll>

      <AnimatedOnScroll animationIn="fadeInUp" animationInDelay="500">
        <Slider {...settings}>
          <div className="partnersCarousel">
            <StaticImage
              width={130}
              src="../images/client/clients.png"
              alt="Partners"
            />
          </div>
          <div className="partnersCarousel">
            <StaticImage src="../images/client/client1.png" alt="Partners" />
          </div>
          <div className="partnersCarousel">
            <StaticImage
              width={200}
              src="../images/client/clients2.svg"
              alt="Partners"
            />
          </div>
          <div className="partnersCarousel">
            <StaticImage src="../images/client/clients3.svg" alt="Partners" />
          </div>
          <div className="partnersCarousel">
            <StaticImage src="../images/client/clients4.svg" alt="Partners" />
          </div>
          <div className="partnersCarousel">
            <StaticImage src="../images/client/clients5.png" alt="Partners" />
          </div>
          <div className="partnersCarousel">
            <StaticImage src="../images/client/clients6.svg" alt="Partners" />
          </div>
          <div className="partnersCarousel">
            <StaticImage src="../images/client/clients7.svg" alt="Partners" />
          </div>
          <div className="partnersCarousel">
            <StaticImage src="../images/client/clients8.png" alt="Partners" />
          </div>
          <div className="partnersCarousel">
            <StaticImage src="../images/client/clients14.png" alt="Partners" />
          </div>
          <div className="partnersCarousel">
            <StaticImage src="../images/client/clients13.png" alt="Partners" />
          </div>
          <div className="partnersCarousel">
            <StaticImage src="../images/client/clients12.png" alt="Partners" />
          </div>
        </Slider>{" "}
      </AnimatedOnScroll>
    </div>
  );
}

export default Partners;
